import { AnyAction } from "redux";
import { ISnackbar } from "store/reducers/snackbars";

export const PUSH_SNACKBAR = "PUSH_SNACKBAR";
export const ACKNOWLEDGE_SNACKBAR = "ACKNOWLEDGE_SNACKBAR";
export const REMOVE_SNACKBAR = "REMOVE_SNACKBAR";

export interface SnackbarsReducerType {
  type: string;
  snackbar: ISnackbar;
  snackbarId: string;
}

export const pushSnackbar = (snackbar: ISnackbar): AnyAction => {
  return {
    type: PUSH_SNACKBAR,
    snackbar
  };
};

export const acknowledgeSnackbar = (
  snackbarId: string
): Partial<SnackbarsReducerType> => {
  return {
    type: ACKNOWLEDGE_SNACKBAR,
    snackbarId
  };
};

export const removeSnackbar = (
  snackbarId: string
): Partial<SnackbarsReducerType> => {
  return {
    type: REMOVE_SNACKBAR,
    snackbarId
  };
};
